<script>
  import { Router, Route } from 'svelte-navigator'

  import Homepage from './Homepage.svelte'
  import PrivacyPolicy from './PrivacyPolicy.svelte'
  import Survey from './Survey.svelte'
  import BestPractices from './BestPractices.svelte'
  import UsefulResources from './UsefulResources.svelte'
  import Insights from './Insights.svelte'
  import Risultati from './Risultati.svelte'
  import DataWall from './DataWall.svelte'
  import { ROUTES } from '../constants/constants'
</script>

<svelte:head>
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
  <link
    href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap"
    rel="stylesheet"
  />
</svelte:head>

<main>
  <Router primary={false}>
    <Route path={ROUTES.homepage}>
      <Homepage />
    </Route>
    <Route path={ROUTES.privacyPolicy}>
      <PrivacyPolicy />
    </Route>
    <Route path={ROUTES.survey}>
      <Survey />
    </Route>
    <Route path={ROUTES.usefulResources}>
      <UsefulResources />
    </Route>
    <Route path={ROUTES.bestPractices}>
      <BestPractices />
    </Route>
    <Route path={ROUTES.insights}>
      <Insights />
    </Route>
    <Route path={ROUTES.results}>
      <Risultati />
    </Route>
    <Route path={`${ROUTES.dataWall}`}>
      <DataWall query={null} />
    </Route>
    <Route path={`${ROUTES.dataWall}/:userId`} let:params>
      <DataWall query={params.userId} />
    </Route>
  </Router>
</main>

<style>
  /* RESET */
  :global(body) {
    margin: 0;
    padding: 0;
    border: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 100%;
    font-family: 'Open Sans', sans-serif;
    background-color: #000;
    overflow-x: hidden;
  }

  :global(h1) {
    font-weight: 600;
  }

  :global(h2) {
    font-size: 24px;
    font-weight: 600;
  }

  :global(label) {
    font-size: 16px;
  }

  :global(a:hover) {
    text-decoration: none;
  }
  /* Select component */
  :global(.selectContainer input) {
    cursor: text !important;
  }

  :global(.listItem .item, .clearSelect) {
    cursor: pointer !important;
  }

  main {
    min-height: 90%;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>
